'use client';

import BaseModal from '@c/modals/BaseModal';
import ChatDetailsContent from './ChatDetailsContent';
import type { ChatDocument } from 'models/chat';
import type { PublicUserDocument, UserDocument } from 'models/user';
import ProductViewerModal from '@c/modals/ProductViewerModal';
import { useState } from 'react';

export type ChatDetailsModalProps = {
  open: boolean;
  dismiss: () => void;
  images?: string[];
  chat: ChatDocument;
  userDoc: UserDocument | null | undefined;
  sellerDoc: PublicUserDocument | null | undefined;
  buyerDoc: PublicUserDocument | null | undefined;
  onArchiveSuccess?: () => void;
};

export default function ChatDetailsModal({
  open,
  dismiss,
  images = [],
  chat,
  userDoc,
  sellerDoc,
  buyerDoc,
  onArchiveSuccess,
}: ChatDetailsModalProps) {
  const [view, setView] = useState<'details' | 'gallery'>('details');
  const [imageModal, setImageModal] = useState<{
    isOpen: boolean;
    index: number;
    images: { full: string; thumb: string; download_url?: string }[];
  }>({ isOpen: false, index: 0, images: [] });

  const onImageClick = (src: string) => {
    const index = images.findIndex((imageUrl) => imageUrl === src);
    const modalImages = images.map((imageUrl) => ({
      full: imageUrl,
      thumb: imageUrl,
      download_url: imageUrl,
    }));
    setImageModal({
      images: modalImages,
      index: index >= 0 ? index : 0,
      isOpen: true,
    });
  };

  return (
    <>
      <BaseModal
        isOpen={open}
        dismiss={dismiss}
        hideCloseIcon={view === 'gallery'}
      >
        <ChatDetailsContent
          buyerDoc={buyerDoc}
          images={images}
          chat={chat}
          sellerDoc={sellerDoc}
          userDoc={userDoc}
          onArchiveSuccess={onArchiveSuccess}
          onDismiss={dismiss}
          view={view}
          setView={setView}
          onImageClick={onImageClick}
        />
      </BaseModal>

      {imageModal.isOpen && (
        <ProductViewerModal
          isOpen={imageModal.isOpen}
          dismiss={() => setImageModal({ ...imageModal, isOpen: false })}
          images={imageModal.images}
          initialImage={imageModal.index}
        />
      )}
    </>
  );
}
